<template>
	<div id="world-quiz-container" :class="'round_'+currentRound" class="world-quiz stage" :style="{ 'background-image': backgroundImage }">
		
		<div class="world-quiz__background-overlay background-overlay">

			
			<div>

				<div class="header__container">
					<div class="header order-2">
						{{questionData.header}}
					</div>
					<div class="subHeader">
						{{questionData.subheader}}
					</div>
					<div class="text">
						{{questionData.header}}
					</div>
				</div>

				<div class="btn__explanation" @click="showExplanationPopup">
					<i class="fa fa-question"></i>
				</div>



				<div class="world-quiz__card">
					<div class="visual-holder">
						<div class="total-counter">Totaal<div class="count-value">{{totalCount}}</div></div>
						<div class="visual-base">
							<div class="visual-items overlay ui-droppable droppable" id="valid_dropzone"></div>
							<img :src="baseUrl + question.visual" id="visual-img"/>
						</div>
					</div>



					<div id="inventory" class="panel centered inventory flex flexColumn">
						<div class="icons flex flexRow flexContent-spaceBetween">
						<!--<div :key="'item_'+index" v-for="(name,index) in names" class="draggable ui-draggable ui-draggable-handle" :id="names[index]">
							<div class="icon">
								<img :src="visuals[index]" :alt="visuals[index]"/>
							</div>
						</div>-->

							<div key="" v-for="(name,index) in names" class="draggable-holder">
			                    <div key="" class="draggable ui-draggable ui-draggable-handle" :id="names[index]">
			                        <div class="icon">
			                            <img :src="baseUrl + visuals[index]"/>
			                        </div>
			                    </div>
			                </div>

			            </div>

						<div class="scores flex flexRow">
							<div v-for="(name,index) in names" class="scores__item">
								<span class="name-label">{{showNames[index]}}</span>
								<br/>
								<span class="score-label">{{Math.round((currentCount[index]/maxCount)*100)}}%</span>

							</div>
						</div>

					</div>
				</div>
			</div>
		</div>

		<div v-if="roundData.hide_explanation === 'Popup'">
			<ExplanationPopup/>

		</div>


		<ExplanationPopup 
		v-if="explanationPopupActive == true" 
		:on-click="hideExplanationPopup"/>
		
	</div>

</template>


<script>

	import Vue from 'vue';
	import {mapGetters , mapActions} from 'vuex';
	import { url} from '../../../const/base';
	import ExplanationPopup from '../ExplanationPopup.vue';

	export default {

		props:[],

		components:{
			ExplanationPopup
		},

		beforeMount(){

			if(this.questionData.type == "Netherland"){
				this.positions.list = this.positions_nl.list;
			}
			
			if(this.questionData.type == "Haarlemmermeer"){
				this.positions.list = this.positions_Haarlemmermeer.list;
			}

			this.positions.list = this.positions.list.splice(0,this.question.total_items);
			this.maxItem = this.question.max_per_item;
			this.maxCount = this.question.total_items;
			for(let item of this.itemArray){

				let newName = item.name.replace(/ /g,"_");

				newName = newName.replace("/","_");

				newName = newName.replace("_&_","_");

				newName = newName.replace("<","_");

				let showName = item.name == "Onbruikbare grond" ? "Onbruikbaar" : item.name;

				this.showNames.push(showName);
				this.names.push(newName);
				this.correctCount.push(item.amount);
				this.currentCount.push(0);
				this.visuals.push(item.visual);
			}
		},

		mounted(){
			let component = this;

			$(".draggable").draggable({
				containment: '.main-frame',
				helper : 'clone',
				start : () => component.startDragging(),
				stop : (ev,ui) => component.stopDragging(ev,ui),
			});


			$(".visual-items").droppable({
				out: (ev, ui) => component.moveOutDropZone(ev,ui),
				over: (ev, ui) => component.moveOverDropZone(ev,ui),
				drop: function(ev,ui){component.dropInDropZone(ev,ui,$(this))},

			});

			this.showTransitorScore(true);

		},
		data(){
			return {
				mouseInDropZone: false,
				baseUrl : url,
				explanationPopupActive: false,
				draggedItems : 0,
				totalCount:'0%',
				showNames:[],
				names:[],
				correctCount:[],
				currentCount:[],
				transitorPoints: 0,
				maxItem:0,
				maxCount:0,
				visuals:[],
				positions:{
					list:[
						{"left":2, "top":10, "r":316},
						{"left":30, "top":65, "r":0},
						{"left":60, "top":25, "r":0},
						{"left":86, "top":38, "r":0},
						{"left":20, "top":20, "r":0},
						{"left":25, "top":40, "r":0},
						{"left":70, "top":36, "r":0},
						{"left":42, "top":54, "r":0},
						{"left":46, "top":8, "r":0},
						{"left":5, "top":46, "r":0},
						{"left": 82, "top": 75, "r": 0},
						{"left": 28, "top": 57, "r": 0},
						{"left": 26, "top": 0, "r": 0},
						{"left": 82, "top": 57, "r": 0},
						{"left": 22, "top": 16, "r": -43},
						{"left": 69, "top": 5, "r": 0},
						{"left": 52, "top": 27, "r": 0},
						{"left": 33, "top": 38, "r": 0},
						{"left": 78, "top": 20, "r": 0},
						{"left": 80, "top": 50, "r": 0}
					],
					used:[]
				},
				positions_nl:{
					list:[
						{"left":58, "top":7, "r":0},
						{"left":30, "top":60, "r":0},
						{"left":60, "top":25, "r":0},
						{"left":52, "top":38, "r":0},
						{"left":30, "top":20, "r":0},
						{"left":25, "top":40, "r":0},
						{"left":70, "top":36, "r":0},
						{"left":42, "top":54, "r":0},
						{"left":74, "top":9, "r":0},
						{"left":60, "top":80, "r":0},
						{"left": 82, "top": 75, "r": 0},
						{"left": 28, "top": 57, "r": 0},
						{"left": 26, "top": 0, "r": 0},
						{"left": 82, "top": 57, "r": 0},
						{"left": 22, "top": 16, "r": 0},
						{"left": 69, "top": 5, "r": 0},
						{"left": 52, "top": 27, "r": 0},
						{"left": 33, "top": 38, "r": 0},
						{"left": 78, "top": 20, "r": 0},
						{"left": 80, "top": 50, "r": 0}
					],
					used:[]
				},
				positions_Haarlemmermeer:{
					list:[
						{"left":65, "top":7, "r":0},
						{"left":23, "top":76, "r":0},
						{"left":60, "top":25, "r":0},
						{"left":43, "top":30, "r":0},
						{"left":65, "top":60, "r":0},
						{"left":25, "top":40, "r":0},
						{"left":70, "top":36, "r":0},
						{"left":42, "top":54, "r":0},
						{"left":12, "top":63, "r":0},
						{"left":46, "top":1, "r":0},
						{"left": 82, "top": 75, "r": 0},
						{"left": 28, "top": 57, "r": 0},
						{"left": 26, "top": 0, "r": 0},
						{"left": 82, "top": 57, "r": 0},
						{"left": 22, "top": 16, "r": 0},
						{"left": 69, "top": 5, "r": 0},
						{"left": 52, "top": 27, "r": 0},
						{"left": 33, "top": 38, "r": 0},
						{"left": 78, "top": 20, "r": 0},
						{"left": 80, "top": 50, "r": 0}
					],
					used:[]
				},
				markerPlaced : false,
				inRedZone : false,


			}
		},


		/*
		POSITIONS EARTH

		positions:{
					list:[
						{"left":2, "top":10, "r":316},
						{"left":30, "top":65, "r":0},
						{"left":60, "top":25, "r":0},
						{"left":86, "top":38, "r":0},
						{"left":20, "top":20, "r":0},
						{"left":25, "top":40, "r":0},
						{"left":70, "top":36, "r":0},
						{"left":42, "top":54, "r":0},
						{"left":84, "top":9, "r":0},
						{"left":5, "top":30, "r":0},
						{"left": 82, "top": 75, "r": 0},
						{"left": 28, "top": 57, "r": 0},
						{"left": 26, "top": 0, "r": 0},
						{"left": 82, "top": 57, "r": 0},
						{"left": 22, "top": 16, "r": -43},
						{"left": 69, "top": 5, "r": 0},
						{"left": 52, "top": 27, "r": 0},
						{"left": 33, "top": 38, "r": 0},
						{"left": 78, "top": 20, "r": 0},
						{"left": 80, "top": 50, "r": 0}
					],
					used:[]
				},
		*/

		watch:{

			currentCount : {
				handler : function(arr){
					let items = 0;
					for(let i = 0 ; i < arr.length ; i++){
						items += arr[i];
						if(arr[i] == this.maxItem){
							$("#"+this.names[i]).addClass("disabled");
						}
						else{
							$("#"+this.names[i]).removeClass("disabled");
						}
					}

					console.log('check:');
					console.log(items);
					console.log(this.maxCount);


					this.totalCount = (items*this.maxCount)+"%";

					if(items == this.maxCount){
						let score = 0;
						for(let i = 0 ; i < arr.length ; i++)
						{
							if(this.currentCount[i] == +this.correctCount[i]){
								score += 100/this.correctCount.length;
								this.transitorPoints += 100/this.correctCount.length;
							}else{
								let diff = this.currentCount[i] - this.correctCount[i];
								if(diff < 0){ diff = diff*-1; }

								// score += ( 100 - (diff*10))/this.correctCount.length;
								// this.transitorPoints += ( 100 - (diff*10))/this.correctCount.length;

								score += ( 25 - (diff*10));
								this.transitorPoints += ( 25 - (diff*10));
							}
							$("#"+this.names[i]).addClass("disabled");
						}



						//do this at feedback screen
						// this.increaseTransitorScore(parseInt(this.roundData.questions.transitor_multiplier*(this.transitorPoints/10)));

						console.log('score');
						console.log(score);

						this.setRoundScore(score).then(()=>{
							this.setNextButtonAction(this.finishWorldRound).then(()=>{
								this.setFeedbackData({
									correctScores: this.correctCount,
									currentScores: this.currentCount,
									names: this.names,
									totalScores: this.maxCount,
									transitors:parseInt(this.roundData.questions.transitor_multiplier*(this.transitorPoints/10))
								}).then(()=>{
									this.showNextButton({"btn":true , "btn-progres":true , "btn-progres-utrecht-whiteLine":true});
								});
							});
						});
					}
					else{
						this.hideNextButton();
					}

				},
				deep: false
			},
		},

		computed:{

			...mapGetters([
				'currentBlock',
				'currentStage',
				'currentRound',
				'roundScore',
				'questionData',
				"roundData",
				'stageData'
			]),

			question(){return this.questionData;},
			
			itemArray(){return this.question.items},

			backgroundImage: function() {
		        return 'url('+ this.baseUrl + this.roundData.questions.question_background + ')';
		    },

		},


		methods:{

			...mapActions([
				"showNextButton",
				"hideNextButton",
				"setRoundScore",
				"logAnswers",
				"completeRound",
				"setNextButtonAction",
				"setFeedbackData",
				"increaseTransitorScore",
				"showTransitorScore",
			]),

			hideExplanationPopup(){
				this.explanationPopupActive = false;
				$('.btn--transition').removeClass('idle');
			},

			showExplanationPopup(){
				this.explanationPopupActive = true;
				$('.btn--transition').addClass('idle');
			},

			finishWorldRound(){
				this.logAnswers(this.currentCount).then(()=>{
					this.completeRound();
				});
			},

			moveOutDropZone(ev,ui){
				this.mouseInDropZone = false;
				let component = this;
				ui.helper.off('mouseup').on('mouseup', function () {
					let name = $(this).attr('data-type');
					let nameIndex = component.names.indexOf(name);
					if(nameIndex >= 0){
						Vue.set(component.currentCount , nameIndex , component.currentCount[nameIndex]-1);
					}
					let arr = component.positions.used;
					let index = component.positions.used.indexOf(+$(this).attr('count'));
					component.positions.used.splice(index, 1);
					$(this).remove();
				});
			},
			moveOverDropZone(ev,ui){
				this.mouseInDropZone = true;
				ui.helper.off('mouseup').on('mouseup', null);
			},
			dropInDropZone(ev,ui,jqueryContainer){
				if (ev.target.id == "valid_dropzone") {
					let classes = $(ui.draggable).attr("class");
					//If item was already dragged. do not create a copy
					if(classes.includes("item-dragged")) return;
					let element = $(ui.draggable).clone();
					let name = "clonediv" + this.draggedItems;
					element.attr("id", name);
					element.addClass('item-dragged');
					jqueryContainer.append(element);
				}

			},
			startDragging(){
				this.mouseInDropZone = false;
				this.draggedItems ++;

			},
			stopDragging : function (ev, ui) {
				let	screenWidth = $('.main-frame').width();
				let scale = screenWidth/ 460;
				let holder = $('.visual-holder');
				//If our drop position is on our container.
				if(this.mouseInDropZone){
					let objName = "#clonediv" + this.draggedItems;
					if ($(objName))
					{
						$(objName).attr('data-type', ev.target.id);
						this.dropTarget(objName, this[ev.target.id], scale);
						let index = this.names.indexOf(ev.target.id);
						if(index >= 0){
							Vue.set(this.currentCount , index , this.currentCount[index]+1);
						}
					}
				}
			},
			dropTarget(objName, obj , scale){
				//Find the right index number by searching the used array.
				let count = 0;
				if(this.positions.used.length > 0)
				{
					for (let i = 0; i < this.maxCount; i++)
					{
						if(this.positions.used.includes(i)) continue;
						count = i;
						this.positions.used.push(i);
						break;
					}
				}
				else{
					this.positions.used.push(0);
				}
				$(objName).attr('count' , count);


				//we need the factor of the actual image vs the div, so no matter how the image is displayed, the position always matches

				let factor = $('#visual-img').width()/$('#valid_dropzone').width();
				let offset = (100-(factor*100))/2;

				// console.log(this.positions.list[count].left);
				// console.log(factor);
				// console.log(offset);

				$(objName).css({
					width: (60*scale)+"px",
					height: (70*scale)+"px",
					"left": ((this.positions.list[count].left*factor)+offset)+"%",
					"top": this.positions.list[count].top+"%",
					"transform": "rotate("+this.positions.list[count].r+"deg)"
				});

				let component = this;

				$(objName).draggable({
					containment: '.main-frame',
					revert: function(ev,ui){
						let index = component.positions.used.indexOf(+$(this).attr('count'));
						index = component.positions.used[index];
						let draggable = $(this).data('uiDraggable');
						if(draggable != null){
							$(this).data("uiDraggable").originalPosition = {
								left : component.positions.list[index].left+"%",
								top : component.positions.list[index].top+"%"
							};
						}
						return true;
					},
				});

			}
		},
	}
</script>

<style>
	.cls-2{
		opacity: 0 !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/minigames/world/Index.vue